import React from 'react';

import Home from './pages/Home';
import { ApiProvider } from './utils/ApiContext';
import { ModalProvider } from './utils/ModalContext';

export default class App extends React.Component {
  render() {
    return (
      <ApiProvider>
        <ModalProvider>
          <Home />
        </ModalProvider>
      </ApiProvider>
    );
  }
}
